import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'
import { Document } from 'src/app/shared/interface';


@Injectable({
  providedIn: 'root'
})
export class ClientService {

  gsaList: Gsa[] = [
    {
      name: "001", email: "abc@gmail.com", contactNo: "987678765", position: 1,
      role: [
        { roleId: 1, roleName: "Account" },
        { roleId: 2, roleName: "CS" }
      ]
    },
    {
      name: "002", email: "abc@gmail.com", contactNo: "987678765", position: 2,
      role: [{ roleId: 1, roleName: "CS" }]
    },
    { name: null, email: null, contactNo: null, role: [], position: 3 }
  ];
  gsaList$: BehaviorSubject<Gsa[]> = new BehaviorSubject(this.gsaList);

  documentList: Document[] = [
    { documentCode: "001", documentName: "abc@gmail.com", uploadDocument: "abc@gmail.com", position: 1 },
    { documentCode: "002", documentName: "abc@gmail.com", uploadDocument: "abc@gmail.com", position: 2 },
    { documentCode: "003", documentName: "abc@gmail.com", uploadDocument: "abc@gmail.com", position: 3 },
    { documentCode: null, documentName: null, uploadDocument: null, position: 0 },
  ];
  documentList$: BehaviorSubject<Document[]> = new BehaviorSubject(this.documentList);

  roleList: RoleModel[] = [
    { roleId: 1, roleName: "Accountant" },
    { roleId: 2, roleName: "CS" },
    { roleId: 3, roleName: "Developer" }
  ]
  roleList$: BehaviorSubject<RoleModel[]> = new BehaviorSubject(this.roleList);
  constructor() {
  }
  newDynamic: any = {};

  updateGsa(index:number, field:string, value:string) {
    this.gsaList[index][field] = value;
    this.gsaList$.next(this.gsaList);
  }
  removeGsa(index:number) {
    this.gsaList.splice(index, 1);
    this.gsaList$.next(this.gsaList);
  }
  addRowGsa(index:number) {
    this.newDynamic = { name: null, emailId: null, contactNumber: null, role: null, position: index };
    this.gsaList.push(this.newDynamic);
    this.gsaList$.next(this.gsaList);
  }

  addNewRole(index:number, roleName: string) {
    this.newDynamic = { roleName: roleName, roleId: index };
    this.gsaList[index].role.push(this.newDynamic);
    this.gsaList$.next(this.gsaList);
  }
  removeRole(gsaindex:number, roleindex: number) {
    this.gsaList[gsaindex].role.splice(roleindex, 1);
    this.gsaList$.next(this.gsaList);
  }


  updateDocument(index:number, Field:string, Value:string) {
    this.documentList[index][Field] = Value;
    this.documentList$.next(this.documentList);
  }
  removeDocument(index:number) {
    this.documentList.splice(index, 1);
    this.documentList$.next(this.documentList);
  }
  addDocument(index:number) {
    this.newDynamic = { documentCode: null, documentName: null, uploadDocument: null,position: index };
    this.documentList.push(this.newDynamic);
    this.documentList$.next(this.documentList);
  }
}

export interface Gsa {
  name: string;
  email: string;
  contactNo: string;
  position: number;
  role?: RoleModel[];

}



export interface RoleModel {
  roleName: string;
  roleId: number;
  id?: number;
  name?: string;
}

export interface ClientModel {
  clientCode: string;
  clientName: string,
  country: string;
  status: string;
  action: string;
}

export const client_data: ClientModel[] = [
  { clientCode: "G001", clientName: "GRT Logistics", country: 'Cheque', status: "1000", action: '1' },
  { clientCode: "HDFC00102564", clientName: "Cargo Logistics", country: 'Cheque', status: "1000", action: '2' },
  { clientCode: "HDFC00102564", clientName: "All Cargo Logistics", country: 'Cheque', status: "1000", action: '3' },
  { clientCode: "HDFC00102564", clientName: "TNL Logistics", country: 'Cheque', status: "1000", action: '4' },
  { clientCode: "HDFC00102564", clientName: "BNL Logistics", country: 'Cheque', status: "1000", action: '5' },
  { clientCode: "HDFC00102564", clientName: "GRT Logistics", country: 'Cheque', status: "1000", action: '6' },
  { clientCode: "HDFC00102564", clientName: "BNL Logistics", country: 'Cheque', status: "1000", action: '7' },
  { clientCode: "HDFC00102564", clientName: "Type 8", country: 'Cheque', status: "1000", action: '8' },
  { clientCode: "HDFC00102564", clientName: "GRT Logistics", country: 'Cheque', status: "1000", action: '9' },
  { clientCode: "HDFC00102564", clientName: "BNL Logistics", country: 'Cheque', status: "1000", action: '10' },
];